import { render, staticRenderFns } from "./BarCodeRulesDetailsEdit.vue?vue&type=template&id=3988f400&"
import script from "./BarCodeRulesDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./BarCodeRulesDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports